import _ from "lodash"

export const isFormFieldValid = (formik, name) => {
  if (
    (formik?.touched[name] || formik.submitCount > 0) &&
    formik?.errors[name]
  ) {
    return true
  } else {
    return false
  }
}

export const getFormErrorMessage = (formik, name) => {
  return (
    isFormFieldValid(formik, name) && (
      <small className="p-error">{formik?.errors[name]}</small>
    )
  )
}
